var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "task-list-partition" },
    [
      _c(
        "flex-grid",
        { attrs: { width: "100%" } },
        [
          _c(
            "flex-grid-item",
            { attrs: { grow: "1", margin: "10px" } },
            [
              _c("partition-table", {
                attrs: {
                  title: "Activity Partitions",
                  "partition-list": _vm.activityPartitionList
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "flex-grid-item",
            { attrs: { grow: "1" } },
            [
              _c("partition-table", {
                attrs: {
                  title: "Decision Partitions",
                  "partition-list": _vm.decisionPartitionList
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4ee7a3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ee7a3c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/task-list/partition.vue
// module id = 1741
// module chunks = 0